<mat-chip-list class="passwordValidation" aria-label="Passwortstärke">
	<mat-chip [ngClass]="{'checked': validation.length}">{{ 'PASSWORD_VALIDATE_LAENGE' | translate}}</mat-chip>
	<mat-chip [ngClass]="{'checked': validation.lower}">{{ 'PASSWORD_VALIDATE_KLEIN' | translate}}</mat-chip>
	<mat-chip [ngClass]="{'checked': validation.upper}">{{ 'PASSWORD_VALIDATE_GROSS' | translate}}</mat-chip>
	<mat-chip [ngClass]="{'checked': validation.number}">{{ 'PASSWORD_VALIDATE_ZAHL' | translate}}</mat-chip>
	<mat-chip [ngClass]="{'checked': validation.special}">{{ 'PASSWORD_VALIDATE_SONDERZEICHEN' | translate}} <i>{{specialChars}}</i></mat-chip>
</mat-chip-list>
